import { useMemo } from 'react';

export type Company = 'Lidz' | 'Leadnamics';

export interface BrandConfig {
  company: Company;
  displayName: string;
  websiteUrl: string;
  websiteLabel: string;
  appDomain: string;
  appUrl: string;
  supportEmail: string;
}

const LIDZ: BrandConfig = {
  company: 'Lidz',
  displayName: 'Lidz',
  websiteUrl: 'https://www.lidz.ai',
  websiteLabel: 'www.lidz.ai',
  appDomain: 'app.lidz.ai',
  appUrl: 'https://app.lidz.ai',
  supportEmail: 'privacidad@lidz.ai',
};

const LEADNAMICS: BrandConfig = {
  company: 'Leadnamics',
  displayName: 'Leadnamics',
  websiteUrl: 'https://leadnamics.io',
  websiteLabel: 'leadnamics.io',
  appDomain: 'portal.leadnamics.io',
  appUrl: 'https://portal.leadnamics.io',
  supportEmail: 'info@leadnamics.io',
};

export const isLeadnamicsDomain = (): boolean =>
  typeof window !== 'undefined' && window.location.hostname.includes('leadnamics');

const useBrand = (): BrandConfig => useMemo(() => (isLeadnamicsDomain() ? LEADNAMICS : LIDZ), []);

export default useBrand;
